import React, {Component, createRef} from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {fetchMe} from 'redux/users/actions';
import {patchUser, clearPatchUser} from 'redux/settings/actions';
import {PUBLIC_SITE_URL} from 'utils/restapi';

import ShareOptions from 'components/elements/buttons/ShareOptions';

import onClickOutside from 'react-onclickoutside';
import InputField from 'components/elements/InputField';
import FixedNotification from 'components/common/FixedNotification';

import validate from './validate';

import './BaseChangeUsername.css';


const ENTER_KEY = 13;

class BaseChangeUsername extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
    patchUserSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    patchUserSuccess: null,
    patchUserError: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    copyUrl: false,
    invalid: false,
  };

  inputEditFieldRef = createRef();

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.me) {
      this.setState({
        initialValue: this.props.me.username,
        currentValue: this.props.me.username,
      });
    }

    if (this.props.location) {
      const isUsernameFocused = this.useQuery(this.props.location.search);
      if (isUsernameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.me &&
      prevProps.me.username &&
      this.props.patchUserSuccess &&
      this.props.patchUserSuccess.username &&
      prevProps.me.username !== this.props.patchUserSuccess.username
    ) {
      this.props.fetchMe();
      this.props.clearPatchUser();
    }
    if (prevProps.location !== this.props.location) {
      const isUsernameFocused = this.useQuery(this.props.location.search);
      if (isUsernameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  handleClickOutside = () => {
    this._changeValueHandler();
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this._changeValueHandler();
    }
  };

  _changeValueHandler = () => {
    this.setState({invalid: validate(this.state.currentValue)}, this.changeUserName);
  };

  changeUserName = () => {
    const {initialValue, currentValue, invalid} = this.state;

    if (!invalid && currentValue !== initialValue) {
      this.setState({initialValue: currentValue});
      const form = new FormData();
      form.append('username', currentValue);
      this.props.patchUser(form);
    }
  };

  errorHandler = () => {
    const {patchUserError} = this.props;
    let error = null;

    if (patchUserError && patchUserError.username && patchUserError.username.length > 0) {
      error = {id: 'basic-username-error', text: patchUserError.username[0]}
    }

    if (this.state.invalid) {
      error = {id: 'basic-username-error', text: this.state.invalid.text};
    }
    return error;
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  }

  render() {
    const {patchUserError, me, patchUserSuccess} = this.props;
    const {currentValue, copyUrl} = this.state;
    const siteUrl = `${PUBLIC_SITE_URL.replace(/^https?\:\/\//i, "")}/`;

    return (
      <Translation>
        {(t) => (
          <div className="basic-change-username__component">
            <div className="basic-change-username-wrapper">
              {/* Input Wrapper */}
              <div
                className={`input-wrapper ${currentValue && currentValue.length >= 15 ? 'full-width' : ''}`}>

                <span className="prefix">{siteUrl}</span>
                <InputField
                  value={currentValue}
                  onChange={(e) => {
                    e.preventDefault();
                    this.setState({currentValue: e.target.value.trim()});
                  }}
                  customRef={this.inputEditFieldRef}
                  error={this.errorHandler()}
                  validate={validate}
                />

                {!patchUserError && patchUserSuccess &&
                <div className="success-icon"/>
                }
              </div>
              <div className="subtext">{t("Profile Username")}</div>
            </div>
            <div className="basic-change-username-sharing-options">
              <ShareOptions
                className="share-basic-change-username__component"
                copyText={me.url}
                copyBtnText={t("Copy Full Link")}
                onCopy={() => {
                  this.setState({copyUrl: true});
                }}
              />
            </div>

            {copyUrl === true &&
            <FixedNotification
              onFadeComplete={() => {
                this.setState({copyUrl: false});
              }}
            >
              {t("Link has been copied: paste it anywhere!")}
            </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    patchUser,
    clearPatchUser,
  },
)(withRouter(onClickOutside(BaseChangeUsername)));
